import { DebugKey, createDebug } from '@ps/web-core-utils';
import type { History } from 'history';
import type { MouseEvent } from 'react';

import { getState, select } from '@swf/core/store';

import { matchC2L, matchRoute, stripC2l } from './matchRoute';

const debug = createDebug(DebugKey.C2L);

/**
 * handle incoming C2Ls.  Matches incoming C2L with regex in ./routes
 * Params are extracted where appropriate.  NB. Not all C2Ls are supported - see ./routes
 * @param c2lPath - incoming c2l path string
 * @param history - route history
 */
export const c2lHandler = (
  c2lPath: string,
  history: History,
  navigate?: (path: string) => void | undefined
) => {
  debug('Handle C2L: %s', c2lPath);

  const rootState = getState();
  const isEmbedded = select.device.isEmbedded(rootState);
  const isEmbeddedPRHubModal = select.location.isEmbeddedPRHubModal(rootState);
  const matchedC2LRoute = matchC2L(c2lPath);

  if (isEmbedded && isEmbeddedPRHubModal && !matchedC2LRoute?.route?.leadToPRHub) {
    const embeddedC2L = stripC2l(c2lPath);
    window?.starsweb?.app.execute(embeddedC2L);
  } else {
    matchedC2LRoute?.route?.handler?.({ path: matchedC2LRoute.match, history, navigate });
  }
};

export const routeHandler = (
  path: string | undefined | null,
  history: History,
  event?: MouseEvent
) => {
  const matchedRoute = path && matchRoute(path);
  if (matchedRoute) {
    event?.preventDefault();
    if (matchedRoute.route.handler) {
      matchedRoute.route.handler({ path: matchedRoute.match, history });
    }
    return true;
  }
};
